import { render, staticRenderFns } from "./Strategies.vue?vue&type=template&id=86ba2582&scoped=true&"
import script from "./Strategies.vue?vue&type=script&lang=js&"
export * from "./Strategies.vue?vue&type=script&lang=js&"
import style0 from "./Strategies.vue?vue&type=style&index=0&id=86ba2582&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86ba2582",
  null
  
)

export default component.exports